/* eslint-disable react/jsx-pascal-case */
import styled from "styled-components";

//#region COMPONENTS
import NanoFlex from "../../Elements/NanoFlex";
import Type from "../../Elements/Typography";
import SingleSelectionDropdown from "../../Elements/SingleSelectionDropdown";
import Switch from "../../Elements/Switch";
//#endregion

//#region UTILS
import { useTranslation } from "react-i18next";
//#endregion

const StyledMapFilters = styled(NanoFlex)``;

export default function MapFilters({
  setIndicatorCallback,
  setSeverityCallback,
  setAllHousesCallback,
  indicatorSelected,
  severitySelected,
  allHouses,
}) {
  //TRANSLATION INIT
  const { t } = useTranslation();

  return (
    <StyledMapFilters>
      <NanoFlex flexDirection={"column"} alignItems={"start"}>
        <Type.p className="titleForm">
          <b>{t("map.selectIndicator")}</b>
        </Type.p>
        <SingleSelectionDropdown
          placeholder="Placeholder"
          searchable={false}
          selected={indicatorSelected}
          options={[
            { id: 1, name: t("temperature") },
            { id: 2, name: t("humidity") },
            { id: 3, name: t("airQuality") },
            { id: 4, name: t("inactivity") },
            { id: 5, name: t("illuminance") },
            { id: 6, name: t("noise") },
            { id: 7, name: t("energy") },
          ]}
          onChangeSelection={(e) => {
            setIndicatorCallback(e?.id);
          }}
        />
      </NanoFlex>
      <NanoFlex flexDirection={"column"} alignItems={"start"}>
        <Type.p className="titleForm">
          <b>{t("map.selectSeverity")}</b>
        </Type.p>
        <SingleSelectionDropdown
          placeholder="Placeholder"
          searchable={false}
          selected={severitySelected}
          options={[
            { id: 1, name: t("high") },
            { id: 2, name: t("medium") },
            { id: 3, name: t("low") },
          ]}
          onChangeSelection={(e) => {
            setSeverityCallback(e?.id);
          }}
        />
      </NanoFlex>
      <NanoFlex></NanoFlex>
      <NanoFlex flexDirection={"row"} justifyContent={"flex-end"}>
        <Switch
          text={t("map.allHouses")}
          checked={allHouses}
          onChangeSelection={(e) => {
            setAllHousesCallback(e);
          }}
        ></Switch>
      </NanoFlex>
    </StyledMapFilters>
  );
}
